<template>
  <svg :class="svgClass" aria-hidden="true">
    <use :style="{ fill: svgfill}" v-bind:xlink:href="iconName"/>
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    }    ,
    fillcolor: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName () {
      return `#icon-${this.iconClass}`
    },
    svgClass () {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    },
    svgfill () {
      if (this.fillcolor) {
        return this.fillcolor
      } else {
        return '#000000'
      }
    }
  }
}
</script>

<style scoped>
.svg-icon {
  fill: currentColor;
  overflow: hidden;color:#000000
}
</style>



// WEBPACK FOOTER //
// src/components/SvgIcon/index.vue